module.exports = __webpack_public_path__ + "img/address.43e0e9e5.png";